import { Enum_Context_Type_Enum } from 'common/schema/commonSchemaRemoteTypes';
import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { getDefaultFilters } from './filter.defaults';
import {
  FavoritesModalListMostRecent,
  FavoritesModalListState,
  ListDirection,
  listingDirections,
  ListWindowLoaderStateType,
} from './list.types';
import { FavoritesModalSort, isFavoritesModalort } from './filter.types';
import { filtersHash } from '../hooks/useFavoritesModalFiltersIdentifier';

export const defaults = {
  most_recent: (): {
    type: SortOptionsEnum.MOST_RECENT;
    data: FavoritesModalListMostRecent;
  } => ({
    type: SortOptionsEnum.MOST_RECENT,
    data: {
      __typename: SortOptionsEnum.MOST_RECENT,
      lastScrollPosition: 0,
      detailedToListedStartOffset: 0,
      cursor: [
        {
          favoritedAt: '1000-01-01T00:00:00.000000+00:00',
          favoritedBy: 0,
          favoritedByType: Enum_Context_Type_Enum.Artist,
        },
        {
          favoritedAt: '4000-01-01T00:00:00.000000+00:00',
          favoritedBy: 0,
          favoritedByType: Enum_Context_Type_Enum.Artist,
        },
      ],
      listed: {
        batchSize: 64,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
      detailed: {
        batchSize: 16,
        status: 'COLD',
        values: [],
        hasMore: [false, false],
      },
    },
  }),
};
const defaultFilters = getDefaultFilters();

export const getDefaultListState: () => FavoritesModalListState = () => {
  const currentSort: FavoritesModalSort = isFavoritesModalort(defaultFilters.currentSort)
    ? defaultFilters.currentSort
    : SortOptionsEnum.MOST_RECENT;

  return {
    identifier: filtersHash(defaultFilters),
    ...defaults[currentSort](),
  };
};

export const listInitialState = getDefaultListState();

export const hasMore = (loader: ListWindowLoaderStateType<unknown, unknown>, direction: ListDirection): boolean =>
  loader.hasMore[listingDirections.indexOf(direction)];
